export const desktop = '1080px';
export const tablet = '961px';
export const mobile = `767px`;
